var Etl = /** @class */ (function () {
    function Etl(_a) {
        var id = _a.id, datasourceId = _a.datasourceId, sql = _a.sql, name = _a.name, state = _a.state, destination = _a.destination, destinationColumnId = _a.destinationColumnId, frequency = _a.frequency, insertType = _a.insertType, createdAt = _a.createdAt, updatedAt = _a.updatedAt, lastExecutedAt = _a.lastExecutedAt;
        this.id = id;
        this.datasourceId = datasourceId;
        this.sql = sql;
        this.name = name;
        this.state = state;
        this.destination = destination;
        this.destinationColumnId = destinationColumnId;
        this.frequency = frequency;
        this.insertType = insertType;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.lastExecutedAt = lastExecutedAt;
    }
    Etl.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, datasourceId = _a.datasourceId, sql = _a.sql, name = _a.name, state = _a.state, destination = _a.destination, destinationColumnId = _a.destinationColumnId, frequency = _a.frequency, insertType = _a.insertType, createdAt = _a.createdAt, updatedAt = _a.updatedAt, lastExecutedAt = _a.lastExecutedAt;
        if (typeof id !== 'string')
            throw new Error('id must be a string');
        if (typeof datasourceId !== 'string')
            throw new Error('datasourceId must be a string');
        if (typeof name !== 'string')
            throw new Error('name must be a string');
        if (typeof state !== 'string')
            throw new Error('state must be a string');
        if (typeof destinationColumnId !== 'string')
            throw new Error('destinationColumnId must be a string');
        if (typeof frequency !== 'string')
            throw new Error('frequency must be a string');
        if (typeof createdAt !== 'string')
            throw new Error('createdAt must be a string');
        if (typeof updatedAt !== 'string')
            throw new Error('updatedAt must be a string');
        if (typeof lastExecutedAt !== 'string')
            throw new Error('lastExecutedAt must be a string');
        return new Etl({
            id: id,
            datasourceId: datasourceId,
            sql: sql,
            name: name,
            state: state,
            destination: destination,
            destinationColumnId: destinationColumnId,
            frequency: frequency,
            insertType: insertType,
            createdAt: createdAt,
            updatedAt: updatedAt,
            lastExecutedAt: lastExecutedAt,
        });
    };
    return Etl;
}());
export default Etl;
